"use strict";function getCurrentId$(d){return ddSdk_1.ddSdk.invokeAPI(apiName,d)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.getCurrentId$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="ui.nav.getCurrentId";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"2.6.0"},_a[ddSdk_1.ENV_ENUM.android]={vs:"2.6.0"},_a)),exports.getCurrentId$=getCurrentId$,exports.default=getCurrentId$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/ui/nav/getCurrentId.js
// module id = 1093
// module chunks = 106